import React from "react";
import { Loader2, Search, X } from "lucide-react";

import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { cn } from "@/lib/utils";

/**
 * The filter box on a usage table.
 *
 * Square and page-coloured, unlike the app's rounded `SearchInput`: it sits
 * inside a card, beside that card's heading, rather than at the top of a page.
 *
 * `loading` puts the spinner exactly where the clear button is, so a
 * server-side search never shifts the row. Only one of the two ever shows.
 *
 * @param {boolean} [loading]  a request is in flight for this search
 */
const UsageSearchField = ({ value, onChange, placeholder = "Search", loading = false, className = "", inputClassName = "", clearLabel = "Clear search" }) => (
  <div className={cn("relative", className)}>
    <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-text-secondary" />
    <Input
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className={cn("h-9 bg-background-primary py-0 pl-9 pr-9 transition-colors focus:border-tone-blue", inputClassName)}
    />
    <span className="absolute right-2.5 top-1/2 -translate-y-1/2">
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin text-text-secondary" />
      ) : value ? (
        <Button onClick={() => onChange("")} aria-label={clearLabel} className="rounded-md p-0 text-text-secondary transition-colors hover:text-text-primary">
          <X className="h-4 w-4" />
        </Button>
      ) : null}
    </span>
  </div>
);

export default UsageSearchField;
